// HUD: ship status card, the fire-control state-machine widget, compartment
// labels, the message log, captain's orders checklist, deck-plan map (M),
// help (H), and the big win/lose banners.

import { V, DECKS, KTS } from "./const.js";
import { FC_STEPS } from "./firecontrol.js";

const $ = (id) => document.getElementById(id);

const MAP_LEVELS = [
  { walk: 3, name: "HOLD / MACHINERY" },
  { walk: 8, name: "THIRD DECK" },
  { walk: 11, name: "SECOND DECK" },
  { walk: 14, name: "MAIN DECK" },
  { walk: 17, name: "01 LEVEL" },
  { walk: 23, name: "BRIDGE (04)" },
];

export class Hud {
  constructor(G) {
    this.G = G;
    this.msgs = [];
    this.mapLevel = 3; // index into MAP_LEVELS (main deck)
    this.mapOpen = false;
    this.helpOpen = false;
    this.tpOpen = false;
    this.clock = 0;
    this.orders = [];
    $("bb-ship").classList.remove("hidden");
    $("bb-fc").classList.remove("hidden");
    $("bb-room").classList.remove("hidden");
    this.buildChain();

    // Touch niceties that cost desktop nothing: tap outside the teleport
    // card to carry on walking, tap the help card away, tap the orders card
    // to fold/unfold it (it starts folded on a phone — vertical pixels are
    // the scarcest thing aboard).
    $("bb-tp").addEventListener("click", (e) => { if (e.target.id === "bb-tp") this.toggleTeleport(false); });
    $("bb-help").addEventListener("click", () => { if (this.helpOpen) this.toggleHelp(); });
    $("bb-orders").addEventListener("click", () => {
      if (!this.G.touch) return;
      this.ordersCollapsed = this.ordersCollapsed === false;
      this.renderOrders();
    });
  }

  buildChain() {
    const el = $("fc-chain");
    el.innerHTML = FC_STEPS.map((s) => `<span class="fc-step" data-s="${s}">${s}</span>`).join("");
  }

  log(text, cls) {
    const G = this.G;
    const el = document.createElement("div");
    el.className = "bb-msg" + (cls ? " " + cls : "");
    el.textContent = text;
    const box = $("bb-log");
    box.appendChild(el);
    this.msgs.push({ el, t: 14 });
    if (this.msgs.length > 7) { const m = this.msgs.shift(); m.el.remove(); }
  }

  setOrders(list, title) {
    this.orders = list;
    this.ordersTitle = title || "CAPTAIN'S NIGHT ORDERS";
    this.renderOrders();
  }
  completeOrder(id) {
    const o = this.orders.find((o) => o.id === id);
    if (o && !o.done) {
      o.done = true;
      this.log(`ORDER COMPLETE: ${o.text}`, "ok");
      this.G.audio.ding();
      this.renderOrders();
    }
  }
  setOrderText(id, text) {
    const o = this.orders.find((o) => o.id === id);
    if (o && o.text !== text) { o.text = text; this.renderOrders(); }
  }
  renderOrders() {
    const el = $("bb-orders");
    el.classList.remove("hidden");
    const next = this.orders.find((o) => !o.done);
    // Folded (touch default): the current order only, with a running tally.
    if (this.G.touch && this.ordersCollapsed !== false) {
      const done = this.orders.filter((o) => o.done).length;
      el.innerHTML = `<h4>${this.ordersTitle} — ${done}/${this.orders.length} ▾</h4>` +
        (next ? `<div class="ord now">☐ ${next.text}</div>` : `<div class="ord done">☑ all orders executed</div>`);
      return;
    }
    el.innerHTML = `<h4>${this.ordersTitle}</h4>` + this.orders.map((o) =>
      `<div class="ord ${o.done ? "done" : o === next ? "now" : ""}">${o.done ? "☑" : "☐"} ${o.text}</div>`).join("");
  }

  banner(title, sub, bad) {
    const el = $("bb-banner");
    el.className = bad ? "bad" : "";
    el.classList.remove("hidden");
    el.innerHTML = `<h2>${title}</h2><p>${sub}</p>`;
  }

  toggleMap() {
    this.mapOpen = !this.mapOpen;
    $("bb-map").classList.toggle("hidden", !this.mapOpen);
    if (this.mapOpen) this.drawMap();
  }
  mapLevelShift(d) {
    this.mapLevel = Math.max(0, Math.min(MAP_LEVELS.length - 1, this.mapLevel + d));
    if (this.mapOpen) this.drawMap();
  }

  drawMap() {
    const G = this.G;
    const box = $("bb-map");
    const lvl = MAP_LEVELS[this.mapLevel];
    // Build the skeleton once and keep it: this redraws 5×/s while open, and
    // the deck buttons must survive between a finger's down and its up.
    if (!$("bb-map-canvas")) {
      box.innerHTML = `<h3 id="bb-map-title"></h3>
        <canvas id="bb-map-canvas" width="1140" height="200"></canvas>
        <p><button class="st-btn" data-map="-1">▼ deck down [</button>
          <button class="st-btn" data-map="1">▲ deck up ]</button>
          <button class="st-btn" data-map="x">✕ close (M)</button>
          &nbsp; gold = ladders &nbsp; ● you &nbsp; · crew</p>`;
      for (const b of box.querySelectorAll("[data-map]")) {
        b.addEventListener("click", (e) => {
          e.stopPropagation();
          if (b.dataset.map === "x") this.toggleMap();
          else this.mapLevelShift(+b.dataset.map);
        });
      }
    }
    $("bb-map-title").textContent = `DECK PLANS — ${lvl.name}`;
    const cv = $("bb-map-canvas");
    const ctx = cv.getContext("2d");
    ctx.fillStyle = "#0a1220"; ctx.fillRect(0, 0, cv.width, cv.height);
    const g = G.ship.grid;
    const sc = 4, ox = 30, oy = 30; // 4 px per meter, x right = bow right
    const walk = lvl.walk;
    for (let x = 0; x < g.nx; x++) {
      for (let z = 0; z < g.nz; z++) {
        const t = g.get(x, walk, z), below = g.get(x, walk - 1, z);
        let c = null;
        if (VSOLID(t)) c = "#3c4a5e";                       // wall/blockage
        else if (t === V.LADDER) c = "#ffcf5c";
        else if (VSOLID(below) || below === V.LADDER) c = "#17293c"; // walkable
        if (c) { ctx.fillStyle = c; ctx.fillRect(ox + x * sc, oy + z * sc, sc, sc); }
      }
    }
    // room labels on this level
    ctx.font = "10px monospace"; ctx.textAlign = "center";
    for (const r of G.ship.rooms) {
      if (r.walk !== walk) continue;
      ctx.fillStyle = "rgba(215,227,244,0.85)";
      ctx.fillText(r.name.split(" — ")[0], ox + (r.x0 + r.x1) / 2 * sc, oy + ((r.z0 + r.z1) / 2) * sc + 3);
    }
    // crew dots
    ctx.fillStyle = "#7f97b8";
    for (const s of G.crew.sailors) {
      if (Math.abs(s.pos.y - walk) > 1.6) continue;
      ctx.fillRect(ox + s.pos.x * sc - 1, oy + s.pos.z * sc - 1, 3, 3);
    }
    // objective beacon
    const wp = G.waypoint;
    if (wp?.anchor) {
      if (Math.abs(wp.anchor.y - walk) <= 1.6) {
        ctx.strokeStyle = "#ffcf5c"; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(ox + wp.anchor.x * sc, oy + wp.anchor.z * sc, 8, 0, Math.PI * 2); ctx.stroke();
        ctx.fillStyle = "#ffcf5c"; ctx.font = "11px monospace"; ctx.textAlign = "center";
        ctx.fillText("◆ " + wp.label, ox + wp.anchor.x * sc, oy + wp.anchor.z * sc - 12);
      } else {
        ctx.fillStyle = "#ffcf5c"; ctx.font = "11px monospace"; ctx.textAlign = "right";
        const how = this.G.touch ? "work the deck buttons" : "press [ or ]";
        ctx.fillText(`objective ◆ ${wp.label} is on ${nearestDeckName(wp.anchor.y)} — ${how}`, ox + 271 * sc, 14);
      }
    }
    // player
    const p = G.player.pos;
    if (Math.abs(p.y - walk) <= 1.6) {
      ctx.fillStyle = "#ffcf5c";
      ctx.beginPath(); ctx.arc(ox + p.x * sc, oy + p.z * sc, 5, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = "#0a1220";
      ctx.beginPath(); ctx.arc(ox + p.x * sc, oy + p.z * sc, 2, 0, Math.PI * 2); ctx.fill();
    } else {
      ctx.fillStyle = "rgba(255,207,92,0.5)"; ctx.font = "11px monospace"; ctx.textAlign = "left";
      const cur = nearestDeckName(p.y);
      const how = this.G.touch ? "work the deck buttons" : "press [ or ]";
      ctx.fillText(`you are on ${cur} — ${how} to find yourself`, ox, 14);
    }
    ctx.fillStyle = "#7f90a8"; ctx.font = "11px monospace";
    ctx.textAlign = "left"; ctx.fillText("STERN", ox, oy + 160);
    ctx.textAlign = "right"; ctx.fillText("BOW →", ox + 271 * sc, oy + 160);
  }

  // Rooms worth teleporting to: everything that doesn't already have a
  // station inside it (those are on the numbered list), high decks first.
  teleportRooms() {
    const ship = this.G.ship;
    const hasStation = (r) => ship.stations.some((s) =>
      s.pos.x >= r.x0 && s.pos.x <= r.x1 && s.pos.z >= r.z0 && s.pos.z <= r.z1 &&
      Math.abs(s.pos.y - r.walk) <= 2);
    return ship.rooms.filter((r) => !hasStation(r))
      .sort((a, b) => b.walk - a.walk || b.x0 - a.x0);
  }

  toggleTeleport(force) {
    this.tpOpen = force !== undefined ? force : !this.tpOpen;
    const el = $("bb-tp");
    el.classList.toggle("hidden", !this.tpOpen);
    if (!this.tpOpen) { el.innerHTML = ""; this.tpRoomKeys = null; return; }
    const sts = this.G.ship.stations;
    const rooms = this.teleportRooms();
    const LETTERS = "ABCDFGHIJKLMNOPQRSUVWXYZ"; // E and T stay "exit menu"
    this.tpRoomKeys = {};
    // Each station row names the compartment it lives in — the orders send
    // you to "CIC" or "plot", so the menu must answer in the same words.
    const stationRoom = (s) => this.G.ship.rooms.find((r) =>
      s.pos.x >= r.x0 && s.pos.x <= r.x1 && s.pos.z >= r.z0 && s.pos.z <= r.z1 &&
      Math.abs(s.pos.y - r.walk) <= 2);
    let stHtml = `<h4>BATTLE STATIONS — man on arrival</h4>` + sts.map((s, i) => {
      const room = stationRoom(s);
      const where = `${room ? room.name.split(" — ")[0] + ", " : ""}${deckName(Math.round(s.pos.y))}`;
      return `<div class="tp-row" data-tpst="${i}"><b>${i + 1}</b>&nbsp; ${s.name}<small> — ${where}</small></div>`;
    }).join("");
    let roomHtml = `<h4>COMPARTMENTS</h4><div class="tp-roomlist">`;
    let lastWalk = null;
    rooms.forEach((r, i) => {
      if (i >= LETTERS.length) return;
      const key = LETTERS[i];
      this.tpRoomKeys[`Key${key}`] = r;
      if (r.walk !== lastWalk) {
        lastWalk = r.walk;
        roomHtml += `<div class="tp-row tp-deck">${deckName(r.walk)}</div>`;
      }
      roomHtml += `<div class="tp-row" data-tpkey="Key${key}"><b>${key}</b>&nbsp; ${r.name.split(" — ")[0]}</div>`;
    });
    roomHtml += `</div>`;
    el.innerHTML = `<div class="bb-card"><h3>LAY TO...</h3>
      <div class="tp-cols">
        <div class="tp-col">${stHtml}</div>
        <div class="tp-col rooms">${roomHtml}</div>
      </div>
      <p class="tp-hint">${this.G.touch ? "tap a station or compartment to be piped there — outside the card to carry on walking"
        : "press a key (or click a row) to be piped there &nbsp;·&nbsp; <b>T</b> to carry on walking"}</p></div>`;
    // Rows are click targets too — a mouse could always read the menu but
    // never use it, and a thumb has no other way in.
    for (const row of el.querySelectorAll("[data-tpst]")) {
      row.addEventListener("click", (e) => { e.stopPropagation(); this.G.teleportTo?.(+row.dataset.tpst); });
    }
    for (const row of el.querySelectorAll("[data-tpkey]")) {
      row.addEventListener("click", (e) => { e.stopPropagation(); this.G.teleportToRoom?.(this.tpRoomKeys[row.dataset.tpkey]); });
    }
  }

  toggleHelp() {
    this.helpOpen = !this.helpOpen;
    const el = $("bb-help");
    el.classList.toggle("hidden", !this.helpOpen);
    if (this.helpOpen) {
      const controls = this.G.touch
        ? `<p><b>LEFT THUMB</b> walk (push to the rim to run) &nbsp; <b>RIGHT THUMB</b> look &nbsp; <b>PINCH</b> binoculars
          &nbsp; <b>▲</b> jump / climb &nbsp; tap the <b style="color:var(--gold)">gold prompt</b> to man or secure a station</p>
          <p>chips up top: <b>MAP</b> deck plans &nbsp; <b>LAY TO</b> teleport anywhere aboard &nbsp; <b>GQ</b> general quarters
          &nbsp; <b>FLARE</b> star shell &nbsp; <b>CAM</b> ride the salvo out &nbsp; <b>HELP</b> this card. Every manned console
          shows its controls as buttons.</p>
          <p style="margin-top:8px">The <b style="color:var(--gold)">gold beacon</b> marks your current objective, and the
          brass-gold ladders are how you get between decks: <b>look up the ladder and push the stick forward</b> (or hold <b>▲</b>)
          to climb, and <b>hold the prompt</b> over a hatch to take the ladder down. In a hurry? <b>LAY TO</b> opens the whole
          ship and you're piped straight there.</p>`
        : `<p><b>WASD</b> walk &nbsp; <b>SHIFT</b> run &nbsp; <b>SPACE</b> jump &nbsp; <b>RIGHT MOUSE</b> binoculars &nbsp; <b>E</b> man / secure a station</p>
          <p><b>M</b> deck plans &nbsp; <b>T</b> teleport — every station and compartment &nbsp; <b>G</b> general quarters &nbsp; <b>H</b> this card</p>
          <p style="margin-top:8px">The <b style="color:var(--gold)">gold beacon</b> marks your current objective, and the
          brass-gold ladders are how you get between decks: <b>look up the ladder and hold W</b> (or <b>SPACE</b>) to climb,
          <b>SHIFT</b> beside a ladder or hatch to climb down. In a hurry? <b>T</b> opens the whole ship — stations by
          number, compartments by letter — and you're piped straight there.</p>`;
      el.innerHTML = `<div class="bb-card"><h3>WELCOME ABOARD, SAILOR</h3>
        ${controls}
        <p style="margin-top:8px">The gunnery loop, the way the real Mk 38 system worked: pick up the enemy on the
        <b>SG radar in CIC</b> (01 level) and designate. Below armor in <b>main battery plot</b>, the Mk 8 rangekeeper
        dead-reckons the target from your <b>estimated target course and speed</b> — crank them (<b>A/D</b>, <b>W/S</b>)
        until the generated pen line tracks the radar dots and the gold rate bugs sit on the green. Only one
        course/speed combination matches both: that's the solution. The <b>Mk 38 director</b> above the bridge adds
        range cuts and sharper spotting. When the battery lights READY, press <b>F</b> from plot, bridge, or director —
        and remember a bad rate estimate misses by rate error × time of flight.</p>
        <p style="margin-top:8px"><b>V</b> rides the last salvo out — chase cam on your own 16-inch round, all the way
        to the splash. And if you're <b>in the director when the salvo lands</b>, the spot is YOUR call: the splashes
        come up as pips on the spot scope; park the gold bug on them (<b>U/J</b> add/drop, <b>H/K</b> left/right) and
        <b>C</b> sends the correction to plot. A good call is worth more than any air spot.</p>
        <p style="margin-top:8px">At night, radar sees and eyes don't: <b>I</b> puts a 5-inch <b>star shell</b> beyond
        the designated target — doctrine says silhouette them, and the director is blind until you do. Destroyers will
        press in and fire <b>torpedo spreads</b>; when the lookouts call wakes, turn INTO them and comb the tracks.
        Every mission ends with a <b>gunnery grade</b> — accuracy, dispatch, ship's condition — and the ship
        remembers her records.</p>
        <p style="margin-top:8px">On the gunfire-support missions the spotter calls targets over the net;
        they appear on the CIC scope as gold diamonds. Designate and shoot them like any contact —
        the spotter walks your salvos on with ADD / DROP corrections.</p>
        <p style="margin-top:8px">When they hit back: <b>DC Central</b> (second deck) shows every casualty.
        Repair parties run themselves, but a magazine fire is on YOU — flood it before it cooks off.
        The engine room answers bells; the helm is on the bridge. The gedunk stand is morale-critical.</p></div>`;
    }
  }

  setPrompt(text, opts) {
    const el = $("bb-prompt");
    if (!text) el.classList.add("hidden");
    else { el.classList.remove("hidden"); el.innerHTML = text; }
    // the ladder flag tells touch.js this hold means "reach for the trunk"
    if (opts?.ladder) el.dataset.ladder = "1";
    else delete el.dataset.ladder;
  }

  update(dt) {
    const G = this.G;
    for (let i = this.msgs.length - 1; i >= 0; i--) {
      const m = this.msgs[i];
      m.t -= dt;
      if (m.t <= 0) { m.el.remove(); this.msgs.splice(i, 1); }
    }
    this.clock -= dt;
    if (this.clock > 0) return;
    this.clock = 0.2;

    const s = G.shipState;
    const deg = Math.round((((s.heading * 180 / Math.PI) % 360) + 360) % 360);
    $("bb-ship").innerHTML =
      `<b>USS NEW JERSEY (BB-62)</b><br/>` +
      `HDG ${String(deg).padStart(3, "0")}° &nbsp; ${(s.speed / KTS).toFixed(1)} KTS &nbsp; RUD ${(s.rudder * 180 / Math.PI).toFixed(0)}°<br/>` +
      `${G.gq ? '<span style="color:var(--bad)">GENERAL QUARTERS</span>' : "CONDITION III — CRUISING"}` +
      (Math.abs(s.list) > 0.005 ? `<br/>LIST ${(s.list * 180 / Math.PI).toFixed(1)}°` : "");

    // FC widget
    const fc = G.fc;
    const stepOn = { idle: -1, track: 1, solution: 2, ready: 3, fire: 4, spot: 5 }[fc.state] ?? -1;
    const steps = $("fc-chain").children;
    for (let i = 0; i < steps.length; i++) {
      steps[i].className = "fc-step" + (i < stepOn || (fc.target && i === 0) ? " done" : "") + (i === stepOn ? " on" : "");
    }
    $("fc-q").style.width = `${Math.round(fc.quality * 100)}%`;
    const line = $("fc-line");
    if (!fc.target) line.innerHTML = "No target designated — CIC holds the radar picture.";
    else line.innerHTML = `<b>${fc.target.name}</b> — brg ${fc.bearingText()}° rng ${(fc.targetRange() / 1000).toFixed(1)} km — solution <b>${Math.round(fc.quality * 100)}%</b>` +
      (G.guns.reload > 0 ? ` — loading ${Math.ceil(G.guns.reload)}s` : "");

    // compartment label
    const room = G.roomAt(G.player.pos);
    $("bb-room").innerHTML = room
      ? `${room.name}<small>${deckName(room.walk)} &nbsp;·&nbsp; frame ${Math.round(272 - G.player.pos.x)}</small>`
      : `WEATHER DECK<small>${deckName(Math.round(G.player.pos.y))}</small>`;

    if (this.mapOpen) this.drawMap();
  }
}

function VSOLID(t) {
  return t !== V.AIR && t !== V.LADDER;
}
function deckName(walk) {
  let best = DECKS[0];
  for (const d of DECKS) if (Math.abs(d.walk - walk) < Math.abs(best.walk - walk)) best = d;
  return best.name;
}
function nearestDeckName(y) {
  let best = MAP_LEVELS[0];
  for (const d of MAP_LEVELS) if (Math.abs(d.walk - y) < Math.abs(best.walk - y)) best = d;
  return best.name;
}
